import { equals } from 'ramda'
import { CountryCode } from 'src/api/defs/enums.type'
import { ClientData } from '../auth/registration/RegistrationPage'
import { getEnvConfVal } from '../conf/getEnvConfVal'

export const deepEquals = equals

export const getTopLevelDomain = () => {
    const re = /\.([^.]+?)$/

    const topLevelDomain = re.exec(location.hostname)

    if (topLevelDomain) {
        return topLevelDomain[1]
    }

    return undefined
}

export const scrollToTargetHeaderAdjusted = (id: string): void => {
    const element = document.getElementById(id)
    const headerOffset = 80

    if (!element) return

    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    })
}

export const setCookie = (name: string, value: string, days = 30) => {
    let cookieValue = encodeURIComponent(value)

    if (days) {
        const expirationDate = new Date()
        expirationDate.setDate(expirationDate.getDate() + days)
        cookieValue += `; expires=${expirationDate.toUTCString()}`
    }

    cookieValue += '; path=/; SameSite=Lax'

    document.cookie = `${name}=${cookieValue}`
}

export const getCookie = (name: string): string | null => {
    const cookieName = `${name}=`
    const cookieArray = document.cookie.split(';')

    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim()
        if (cookie.indexOf(cookieName) === 0) {
            return decodeURIComponent(
                cookie.substring(cookieName.length, cookie.length)
            )
        }
    }

    return null
}

export const deleteCookie = (name: string, domain?: string, path = '/') => {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=Lax`
    if (domain) {
        cookieString += `; domain=${domain}`
    }
    document.cookie = cookieString
}

export const parseAddress = (raw: string): ClientData['address'] | null => {
    if (!raw) return null

    const compact = raw.replace(/\s+/g, ' ').trim()

    const parts = compact.split(' ')

    if (parts.length < 3) return null

    const number = parts.pop()! // last token – house number
    const city = parts.shift()! // first token – city (might contain hyphen)
    const street = parts.join(' ') // everything that remains

    if (!/^\d+(\/\d+)?$/.test(number)) return null

    return {
        city,
        street,
        number
    }
}

export const sortByCountryPriority = (
    a: { country?: string },
    b: { country?: string },
    defaultCountry?: CountryCode
): number => {
    const mainCountries = getEnvConfVal('MAIN_COUNTRIES')

    // Prioritize default country first
    if (a.country === defaultCountry && b.country !== defaultCountry) return -1
    if (b.country === defaultCountry && a.country !== defaultCountry) return 1

    const indexA = a.country
        ? mainCountries.indexOf(a.country as CountryCode)
        : -1
    const indexB = b.country
        ? mainCountries.indexOf(b.country as CountryCode)
        : -1

    if (indexA === -1 && indexB === -1) return 0
    if (indexA === -1) return 1
    if (indexB === -1) return -1

    return indexA - indexB
}
